import moment from "moment";
import { connect } from "react-redux";

function WhatsappChatItem({ chat, onClick, config }) {
  const isRTL = config?.direction === "rtl";

  function formatChatTime(date) {
    if (!date) return "";

    const m = moment.utc(date).local();

    if (m.isSame(moment(), "day")) {
      return m.format("HH:mm");
    }

    if (m.isSame(moment().subtract(1, "day"), "day")) {
      return "Yesterday";
    }

    if (m.isSame(moment(), "week")) {
      return m.format("ddd"); // Mon, Tue, Wed
    }

    return m.format("DD/MM/YYYY");
  }

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    direction: isRTL ? "rtl" : "ltr",
  };

  const contentStyle = {
    flex: 1,
    marginLeft: isRTL ? 0 : 10,
    marginRight: isRTL ? 10 : 0,
    overflow: "hidden",
  };

  const nameStyle = {
    fontSize: 14,
    fontWeight: chat.has_unread ? "600" : "500",
    color: "#111",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const lastMsgStyle = {
    fontSize: 12,
    color: "#777",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: 2,
  };

  const rightStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: isRTL ? "flex-start" : "flex-end",
    marginLeft: isRTL ? 0 : 8,
    marginRight: isRTL ? 8 : 0,
  };

  const unreadBadgeStyle = {
    background: "#0099cc",
    color: "#fff",
    fontSize: 11,
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 6,
    padding: "0 5px",
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={contentStyle}>
        <div style={nameStyle}>
          {chat.customer_name || chat.customer_number}
        </div>
        <div style={lastMsgStyle}>{chat.last_message_text || "—"}</div>
      </div>

      <div style={rightStyle}>
        <div style={{ fontSize: 11, color: "#999" }}>
          {chat.last_message_at ? formatChatTime(chat.last_message_at) : ""}
        </div>

        {chat.has_unread ? <div style={unreadBadgeStyle}>●</div> : null}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(WhatsappChatItem);
